import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-28" }

import HeroComponent from "@/components/sections/HeroComponent.vue";
import ServicesComponent from "@/components/sections/ServicesComponent.vue";
import GalleryComponent from "@/components/sections/GalleryComponent.vue";
import ContactComponent from "@/components/sections/ContactComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeroComponent),
    _createVNode(ServicesComponent),
    _createVNode(GalleryComponent),
    _createVNode(ContactComponent)
  ]))
}
}

})